import * as S from './styles.ts';
import { Image, UniversalLink } from '@template/components';

export interface IBrandImageProps {
  src: string;
  alt?: string;
}

const BrandImage = ({ src, alt }: IBrandImageProps) => {
  return (
    <UniversalLink
      href='/'
      title={`Link to ${alt} homepage`}
      aria-label={`Link to ${alt} homepage`}
    >
      <S.BrandImageWrapper>
        <Image src={src} alt={alt} width={64} height={33} />
      </S.BrandImageWrapper>
    </UniversalLink>
  );
};

export default BrandImage;
